import { render, staticRenderFns } from "./dealer_list.vue?vue&type=template&id=c40a654a&scoped=true"
import script from "./dealer_list.vue?vue&type=script&lang=js"
export * from "./dealer_list.vue?vue&type=script&lang=js"
import style0 from "./dealer_list.vue?vue&type=style&index=0&id=c40a654a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40a654a",
  null
  
)

export default component.exports